<template>
<div>
  <singleTermWiseMarkentry v-for="term in markentryConf.termConf.terms" :key="term.id" :markentry-conf="markentryConf" :term-conf="term" @add-term-mark="addTermMark">
  
  </singleTermWiseMarkentry>
</div>
</template>

<script>
import singleTermWiseMarkentry from "./singleTermMarkentry.vue";

export default {
 name: "termwise-markentry",
 components:{
     singleTermWiseMarkentry
 },
 props:{
     markentryConf:Object
 },
 data(){
   return {
     termMarkList:[]
   }
 },
 methods:{
   addTermMark(response){
     const idx = this.termMarkList.findIndex(term => term.term ===response.term);
     if(idx>-1){
       this.termMarkList[idx]=response;
     }
     else{
       this.termMarkList.push(response);
     }
   }
 },
 watch:{
   termMarkList(){
     this.$emit('save-mark',this.termMarkList);
   }
 }
}
</script>

<style>

</style>